/**
 * @format
 * @description Object describing the token types
 */

export enum TracerToken {
  CART = 'cart_tracer',
  CATEGORY = 'clp_tracer',
  FAMILY = 'plp_tracer',
  HOME = 'home_tracer',
  SAVE_THE_SALE = 'save_the_sale_tracer',
  SPORTS_HUB = 'sports_hub_tracer',
  MYACCOUNT = 'myaccount_tracer',
  ORIGIN = 'origin_tracer',
  PRODUCT = 'pdp_tracer',
  UNIVERSAL_LOGIN = 'universal_login_tracer',
}
